import React from 'react';
import { useDocumentMetaDataQuery } from '../../../../../ApexOPL/AccountOpening/api/useDocumentMetaDataQuery';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../CommonComponents/OPL/Icon/Icon';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { truncateFileName } from '../../../../../CommonUtils/truncateFileName';

interface Props {
  clientId: string;
  accountId: string;
  snapId: string | null;
}

export const Letter407 = ({ clientId, accountId, snapId }: Props) => {
  const { isFetching, data } = useDocumentMetaDataQuery({
    clientId,
    draftId: accountId,
    snapId: snapId || undefined,
    isAffiliatedExchangeOrFINRA: true,
  });

  if (!snapId) {
    return null;
  }

  if (isFetching) {
    return <Text color="neutral.500">Loading...</Text>;
  }

  if (!data) {
    return null;
  }

  const downloadDocument = () => {
    window.open(
      `/Consumer/ManagedAccounts/DownloadDocument?clientId=${clientId}&id=${accountId}&snapId=${snapId}`,
      '_blank',
    );
  };

  return (
    <Box flex={1} display="flex" alignItems="center" mr="16">
      <Icon className="far fa-file-alt" color="neutral.500" mr="4" />

      <Button variant="link" onClick={downloadDocument}>
        {truncateFileName(data.fileName, 25)}
      </Button>

      <Icon className="fas fa-check-circle" color="success.500" ml="8" />
    </Box>
  );
};
